import calendar from './icons/calendar';
import basketball from './icons/basketball-ball';
import close from './icons/close';
import cup from './icons/cup';
import eyeClosed from './icons/eye-closed';
import eyeOpened from './icons/eye-opened';
import gear from './icons/gear';
import logout from './icons/logout';
import notification from './icons/notification';
import plus from './icons/plus';
import soccer from './icons/soccer-ball';
import support from './icons/support';
import voleyball from './icons/voleyball-ball';
import geoPin from './icons/geo_pin';
import search from './icons/search';
import chevronDown from './icons/chevron-down';
import done from './icons/done';
import up from './icons/up';
import down from './icons/down';
import leftLarge from './icons/left-large';
import rightLarge from './icons/right-large';
import drag from './icons/drag';
import arrowRight from './icons/arrow-right';
import navigation from './icons/navigation';

export const iconsMap = {
  'eye-closed': require('./icons/eye-closed.svg').default,
  'eye-opened': require('./icons/eye-opened.svg').default,
  close: require('./icons/close.svg').default,
  plus: require('./icons/plus.svg').default,
  gear: require('./icons/gear.svg').default,
  notification: require('./icons/notification.svg').default,
  support: require('./icons/support.svg').default,
  cup: require('./icons/cup.svg').default,
  calendar: require('./icons/calendar.svg').default,
  logout: require('./icons/logout.svg').default,
  'league-logo': require('./icons/league-logo.svg').default,
  'soccer-field': require('./icons/league-logo.svg').default,
  'down-indicator': require('./icons/down-indicator.svg').default,
  up: require('./icons/up.svg').default,
  down: require('./icons/down.svg').default,
  'left-large': require('./icons/left-large.svg').default,
  'right-large': require('./icons/right-large.svg').default,
  drag: require('./icons/drag.svg').default,
  tournament_1: require('./icons/tournaments_logo/tournament_1.png'),
  tournament_2: require('./icons/tournaments_logo/tournament_2.png'),
  tournament_3: require('./icons/tournaments_logo/tournament_3.png'),
  tournament_4: require('./icons/tournaments_logo/tournament_4.png'),
};

export const pathsMap = {
  cup: cup,
  'baskeball-ball': basketball,
  calendar: calendar,
  close: close,
  'eye-closed': eyeClosed,
  'eye-opened': eyeOpened,
  gear: gear,
  logout: logout,
  notification: notification,
  plus: plus,
  'soccer-ball': soccer,
  support: support,
  'voleyball-ball': voleyball,
  'geo-pin': geoPin,
  search: search,
  'chevron-down': chevronDown,
  done: done,
  up: up,
  down: down,
  'left-large': leftLarge,
  'right-large': rightLarge,
  drag: drag,
  'arrow-right': arrowRight,
  navigation: navigation,
};
